import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { AppTheme } from '../constants/common';
import { State } from '../interface';

const getQuery = () => window?.matchMedia('(prefers-color-scheme: dark)');

const getColorScheme = (isDark: boolean) => (isDark ? AppTheme.DARK : AppTheme.LIGHT);

export default function useResolvedColorScheme() {
	const [preferredColorScheme, setPreferredColorScheme] = useState<AppTheme>(getColorScheme(getQuery().matches));
	const colorScheme = useSelector<State, AppTheme>((state) => state.navigation.appTheme);

	useEffect(() => {
		const listener = (e: MediaQueryListEvent) => setPreferredColorScheme(getColorScheme(e.matches));
		getQuery().addEventListener('change', listener);
		return () => getQuery().removeEventListener('change', listener);
	}, [setPreferredColorScheme]);

	return { resolvedColorScheme: colorScheme === AppTheme.AUTO ? preferredColorScheme : colorScheme, preferredColorScheme };
}
